import { render, staticRenderFns } from "./FormToAdd.vue?vue&type=template&id=428b212a&"
import script from "./FormToAdd.vue?vue&type=script&lang=js&"
export * from "./FormToAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports